import React from "react";
import { Row, Col, Breadcrumb, Table, Button, Modal, DropdownButton, Dropdown } from "react-bootstrap";
import { Link } from "react-router-dom";
import Navigation from "../components/Navigation/Navigation";
import Footer from "./Footer/Footer";
import { Redirect } from "react-router";
import firebase from "../Utils/Firebase";
import User from "../model/User";

class Salons extends React.Component {
  state = {
    sideMenu: true,
    loading: true,
    redirect: false,
    modalShow: false,
    wantVoucher: false,
  };

//   this.wantVoucher = this.wantVoucher.bind(this)
// }

  _onSideMenu = (active) => {
    this.setState({ sideMenu: active });
  };

  async componentDidMount() {
    let App = this;
    this.myInterval = setInterval(() => {
      this.setState({ loading: false });
    }, 1000);

    let dateA = new Date(0);
    let dateB = new Date(0);
    User.getInstance().salons.sort((a, b) => {
      return dateB - dateA;
    });

    this.receivedData();
  }

  // componentDidUpdate() {
  //   console.log(this.state)
  // }

  handlePageClick(e) {
    document.getElementById("tbody").innerHTML = null;
    const selectedPage = e.selected;
    const offset = selectedPage * this.state.perPage;

    this.setState(
      {
        currentPage: selectedPage,
        offset: offset,
      },
      () => {
        this.receivedData();
      }
    );
  }

  receivedData() {
    let App = this;
    const data = User.getInstance().salons;
    let i = 0;

    data.forEach((element) => {
      i = i + 1;
      let row = document.createElement("tr");
      row.onclick = function() {
        User.getInstance().selectedUser = element;
        App.setState({ redirect: true });
      };
      let index = document.createElement("td");
      index.className = "text-center";
      index.innerText = i;
      let fname = document.createElement("td");
      fname.className = "text-center";
      fname.innerText = element.fullName;
      let email = document.createElement("td");
      email.className = "text-center";
      email.innerText = element.email;
      let phoneNumber = document.createElement("td");
      phoneNumber.className = "text-center";
      phoneNumber.innerText = element.phoneNumber;
      let uid = document.createElement("td");
      uid.className = "text-center";
      uid.innerText = element.uid;
      let shopName = document.createElement("td");
      shopName.className = "text-center";
      shopName.innerText = element.shopName;
      let shopNumber = document.createElement("td");
      shopNumber.className = "text-center";
      shopNumber.innerText = element.shopNumber;
      let shopAddress = document.createElement("td");
      shopAddress.className = "text-center";
      shopAddress.innerText = element.shopAddress;

      row.appendChild(index);
      row.appendChild(fname);
      row.appendChild(email);
      row.appendChild(phoneNumber);
      row.appendChild(shopName);
      row.appendChild(shopNumber);
      row.appendChild(shopAddress);

      row.appendChild(uid);

      document.getElementById("tbody").appendChild(row);
    });
  }

  wantVoucher(status) {
    //e.preventDefault()
    this.setState({ wantVoucher: status})
  }


  async bulkUpdate() {
    const db = firebase.firestore()
    const limit = 100
    // let itemsCollection = db.collection("items")
    
    //let allItemsResult = await itemsCollection.limit(limit).get()
    //let read = allItemsResult.docs.length
    let saloonCollections = await firebase.firestore().collection("salons").limit(limit).get()
     let read1 = saloonCollections.docs.length
    while (read1 > 0){
      let batch = firebase.firestore().batch()
      let updated = 0
      saloonCollections.docs.forEach((queryResult) => {
        const doc = queryResult.data()
        if (!doc.websiteUrl){
          updated++

          batch.update(queryResult.ref, {
            websiteUrl: ''
          })
        }
      })
      await batch.commit()
      console.log(`Updated ${updated} of ${read1} items!`)
      return
    }
  
    // while (read > 0) {
    //   const batch = db.batch()
    //   let updated = 0
  
    //   allItemsResult.docs.forEach((queryResult) => {
    //     const doc = queryResult.data()
  
    //     if (!doc.dateUnix) {
    //       updated++
  
    //       batch.update(queryResult.ref, {
    //         // getTime() returns milliseconds
    //         // We convert to seconds and remove any fractional part
    //         dateUnix: (doc.date.toDate().getTime() / 1000) | 0,
    //       })
    //     }
    //   })
    // }
  
    // await batch.commit()
    // console.log(`Updated ${updated} of ${read} items!`)
  }

  render() {
    if (this.state.redirect) {
      return <Redirect push to="/barbershop-profile" />;
    }
    return (
      <div className="page-wrapper">
        <Navigation onClick={this._onSideMenu} />

        <div
          className={`main-content d-flex flex-column ${
            this.state.sideMenu ? "" : "hide-sidemenu"
          }`}
        >
          <div className="main-content-header">
            <Breadcrumb>
              <h1>Barbershops</h1>
              <Link to="/dashboard" className="breadcrumb-item">
                Users
              </Link>
              <Breadcrumb.Item active>Barbershops</Breadcrumb.Item>
            </Breadcrumb>
          </div>

          <Row>
            <Col xl={12}>
              <div className="card mb-4">
                <div className="card-body">
                  <div className="card-header">
                    <h5 className="card-title">List of Barbershops</h5>
                  </div>
                  <MyVerticallyCenteredModal
                    show={this.state.modalShow}
                    onHide={() => this.setState({ modalShow: false })}
                    wantVoucher = {this.state.wantVoucher}
                    wantvoucheryes = {() => this.setState ({ wantVoucher: true})}
                    wantvoucherno = {() => this.setState ({ wantVoucher: false})}
                  />
                  {/*<div className="">*/}
                  {/*  <button onClick={this.bulkUpdate}>Bulk Update</button>*/}
                  {/*</div>*/}
                  <Button
                    variant="primary"
                    onClick={() => this.setState({ modalShow: true })}
                  >
                    Add Barbershop
                  </Button>
                  <Table id="myTable" responsive hover striped className="m-0">
                    <thead>
                      <tr>
                        <th className="text-center">#</th>
                        <th className="text-center">Full Name</th>
                        <th className="text-center">Email</th>
                        <th className="text-center">Contact Number</th>
                        <th className="text-center">Shop Name</th>
                        <th className="text-center">Shop Number</th>
                        <th className="text-center">Shop Address</th>
                        <th className="text-center">User Id</th>
                      </tr>
                    </thead>
                    <tbody id="tbody" />
                  </Table>
                </div>
              </div>
            </Col>
          </Row>

          <div className="flex-grow-1" />
          <Footer />
        </div>
      </div>
    );
  }
}

export default Salons;

function MyVerticallyCenteredModal(props) {
  const { wantvoucheryes, wantvoucherno, wantVoucher, ...rest } = props
  return (
    <Modal
      // onHide = {props.onHide}
      // show = {props.show}
      // wantVoucher = {props.wantVoucher}
      // wantvoucheryes = {props.wantvoucheryes}
      // wantvoucherno = {props.wantyoucherno}
      {...rest}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          Add barbershop
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <input type="text" placeholder="Fullname" id="createName" />
        <br />
        <input type="text" placeholder="Email" id="createEmail" />
        <br />
        <input type="text" placeholder="Password" id="createPassword" />
        <br />
        <div>
        <h5 className="card-title">Has opt in to voucher promo: </h5>
        <DropdownButton
            id="dropdown-basic-button"
            title={props.wantVoucher ? "Yes" : "No"}
            variant={
              props.wantVoucher ? "success" : "danger"
            }
          >
            <Dropdown.Item
              onClick={props.wantvoucheryes}
            >
              Yes
            </Dropdown.Item>
            <Dropdown.Item
              onClick={props.wantvoucherno}
            >
              No
            </Dropdown.Item>
          </DropdownButton>
        </div>
        <br />
        <button onClick={() => createBarbershop()}>Add Barbershop</button>
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={props.onHide}>Close</Button>
      </Modal.Footer>
    </Modal>
  );
}

function createBarbershop() {
  let email = document.getElementById("createEmail").value;
  let password = document.getElementById("createPassword").value;
  let fullname = document.getElementById("createName").value;
  let wantVoucher =  document.getElementById("dropdown-basic-button").textContent;
  if (wantVoucher === 'Yes') {
    wantVoucher = true
  } else if (wantVoucher === "No") {
    wantVoucher = false
  }
  firebase
    .auth()
    .createUserWithEmailAndPassword(email, password)
    .then((result) => {
      firebase
        .firestore()
        .collection("salons")
        .doc(result.user.uid)
        .set({
          email: email,
          fullName: fullname,
          creationDate: new Date(),
          uid: result.user.uid,
          wantVoucher: wantVoucher
        })
        .then((r) => {
          window.location.reload();
        });
    });
}


